var temHtml =  require("./template.ejs")

var temHtml2 =  require("./template2.ejs")

var dot = require("dot")

var setimer;

var serload = false;
module.exports = {
    init: function(sinput,sdiv,sck){
        $("#a_search").html(dot.template(temHtml))
        this.formKeyUp(sinput,sdiv,sck)
        this.formKeydown(sinput,sdiv,sck)
        this.formSubmit(sinput,sdiv,sck)
        this.closeForm()
     //   this.placeholderIE()
    },

    formSubmit: function(sinput,sdiv,sck){
        var _this = this;
        $("#searchform").on("submit",function(){
            var stxt = $.trim($("#"+sinput).val())
            if(stxt!=""){
                _this.formSearch(sinput,sdiv,stxt,sck,true);
            }
            return !1;
        })
    },
    formKeyUp: function(sinput,sdiv,sck){
        var _this = this;
        var $val = "";
        $("#"+sinput).on("keyup",function(e){
            serload = false;
            e.stopPropagation()
            $val = $.trim($("#"+sinput).val())
            if($val==""){
                clearTimeout(setimer);
                $("#"+sdiv).html("").hide();
                $("."+sdiv).hide()
                $("#enter-label,#enter-so").attr("href","javascript:void(0)").attr("target","_self")
                return !1;
            }
            clearTimeout(setimer);
            if(e.keyCode==38){
                return _this.formMoveDown(sinput,sdiv,-1)
            }
            else if(e.keyCode==40){
                return _this.formMoveDown(sinput,sdiv,1)
            }

            else if($.trim($val)==""){
                return !1;
            }

            setimer  = setTimeout(function(){
                if(!serload){
                    _this.formSearch(sinput,sdiv,$val,sck,false);  
                }
            },300)
        })
    },

    formSearch: function(sinput,sdiv,stxt,sck,issubmit){
        $("#"+sdiv).html("").hide()
        $("."+sdiv).hide()
        if(stxt!=""){
            var t =  encodeURIComponent(stxt)
            $.ajax({
                type:"get",
                url: "//searchapi.eastmoney.com/api/Baike/get?cb=?&input=" + stxt +"&token=D43BF722C8E33BDC906FB84D85E326E8&pi=1&ps=7",
                dataType:"jsonp"
            }).then(function(temp){
                return temp;
            }).done(function(data){
                if(data.Data==null){
                    if(issubmit){
                        window.open("http://so.eastmoney.com/web/s?keyword="+t,"_blank")
                        return !1;
                    }
                    $("."+sdiv).show()
                    $(".search-null").show()
                    $("#search-getall").hide()
                    $("#enter-label").attr("href","http://so.eastmoney.com/web/s?keyword="+t).attr("target","_blank")
                }
               else{
                $("#"+sdiv).html(dot.template(temHtml2)(data)).show()
                $("#"+sdiv+" li .sp").each(function(){
                    if($(this).text()!=""){
                        $(this).html($(this).text().split(stxt).join("<em>"+stxt+"</em>"))
                    }
                })
                $("."+sdiv).show()
                $(".search-null").hide()
                $("#search-getall").show()
                $("#enter-label").attr("href","/item/"+data.Data[0].EncyclopediaName).attr("target","_blank")
               }
               $("#search-getall,#enter-so").attr("href","http://so.eastmoney.com/web/s?keyword="+t).attr("target","_blank")
               
            })
        }
    },

    formKeydown: function(sinput,sdiv,sck){
        // var _this =this;
        $("#"+sinput).on('keydown',function(e){
           if (13 == e.keyCode&&($.trim($(this).val()!=""))) {
                //_this.formSubmit(sinput,sdiv,sck);
                var ah =  $("#"+sdiv+" li");
                var bh = ah.filter('.search-label-active').index();
                if (ah.length > 0){
                  var t = window.location.origin;
                  if(bh!=-1){
                    var z = ah.eq(bh).children("a").attr("title")
                    window.open("/item/"+z,"_self")
                    return !1;
                  }
                  else{
                    var z = ah.eq(0).children("a").attr("title")
                    window.open("/item/"+z,"_self")
                    return !1;
                  }
                }
                else{
                    return !1;
                }
           }
        })
        
    },
    formMoveDown: function(sinput,sdiv,t){
        var  a = $("#"+sdiv+" li");
        if(a.length<1){
            return !1
        }
        var b = a.filter('.search-label-active').index();
        a.removeClass('search-label-active'),
        (b += t) < 0 ? b = a.length - 1 : b >= a.length && (b = 0);
        var c = a.eq(b);
        c.addClass('search-label-active');
        $("#"+sinput).val(c.children("a").attr("title"));
        $("#enter-label").attr("href","/item/"+$("#"+sinput).val())
        $("#enter-so").attr("href","http://so.eastmoney.com/web/s?keyword="+encodeURIComponent($("#"+sinput).val()))
    },
    closeForm: function(){
        $(document).on("click",function(e){
            var a = $('.search-result-div');  
            if(!a.is(e.target) && a.has(e.target).length === 0){
                $('.search-result-div').hide()
            }
        })
        $("#search-label-input").on("click",function(e){
            e.stopPropagation()
            if($.trim($("#search-result-div").html())!=""){
                $('.search-result-div').show();
            }
        })
    },
     /**placeholder兼容IE */
     placeholderIE: function(){
        if(!('placeholder' in document.createElement('input'))){
            $("#search-label-input").val("输入文字搜索...")
            $("#search-label-input").on("focus",function(){
                if($(this).val()=="输入文字搜索..."){
                    $.trim($(this).val("")); 
                }
            })
            $("#search-label-input").on("blur",function(){
                if($.trim($(this).val()=="")){
                    $(this).val("输入文字搜索..."); 
                }
            })
        }
        return !1;
    }
}